import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-16 md:pt-40 md:pb-24 px-6 max-w-7xl mx-auto w-full overflow-hidden" data-id="element-110">
      {/* Logo / Brand mark */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="absolute top-8 left-6 md:left-12 flex items-center gap-2" data-id="element-111">
        <div className="w-8 h-8 rounded-md bg-[#FF6B1A] flex items-center justify-center" data-id="element-112">
          <span className="text-white text-lg font-bold leading-none" data-id="element-113">✈</span>
        </div>
        <span className="text-sm font-semibold tracking-tight" data-id="element-114">
          IMPORTED <span className="text-[#FF6B1A]" data-id="element-115">FOR YOU</span>.
        </span>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center mt-12 md:mt-0" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl order-2 lg:order-1" data-id="element-117">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF6B1A]/10 border border-[#FF6B1A]/20 mb-8" data-id="element-118">
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B1A] animate-pulse" data-id="element-119" />
            <span className="text-xs font-medium text-[#FF6B1A] tracking-wider uppercase" data-id="element-120">
              Nuevo · 20% OFF
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] text-balance mb-6" data-id="element-121">
            La luz LED{' '}
            <span className="font-semibold text-[#FF6B1A]" data-id="element-122">portátil</span> que
            te acompaña a todos lados.
          </h1>
          <p className="text-lg md:text-xl text-[#6B6B6B] font-light mb-10 max-w-lg text-balance" data-id="element-123">
            Lectura, trabajo, viajes y uso diario sin usar las manos.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-124">
            <a href="#oferta" className="w-full sm:w-auto px-8 py-4 bg-[#0A0A0A] text-white rounded-full font-medium hover:bg-[#FF6B1A] transition-colors duration-300 text-center inline-flex items-center justify-center gap-2 group" data-id="element-125">
              Comprar ahora
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" data-id="element-126" />
            </a>
            <a href="#oferta" className="w-full sm:w-auto px-8 py-4 text-[#0A0A0A] rounded-full font-medium hover:text-[#FF6B1A] transition-colors duration-300 text-center underline underline-offset-4 decoration-1" data-id="element-127">
              Ver oferta
            </a>
          </div>

          {/* Quick trust badges */}
          <div className="flex flex-wrap items-center gap-6 mt-10 pt-8 border-t border-black/5" data-id="element-128">
            <div data-id="element-129">
              <div className="text-2xl font-semibold" data-id="element-130">165g</div>
              <div className="text-xs text-[#6B6B6B] uppercase tracking-wider" data-id="element-131">
                Ultra liviana
              </div>
            </div>
            <div className="h-10 w-px bg-black/10" data-id="element-132" />
            <div data-id="element-133">
              <div className="text-2xl font-semibold" data-id="element-134">20h</div>
              <div className="text-xs text-[#6B6B6B] uppercase tracking-wider" data-id="element-135">
                De batería
              </div>
            </div>
            <div className="h-10 w-px bg-black/10" data-id="element-136" />
            <div data-id="element-137">
              <div className="text-2xl font-semibold" data-id="element-138">3</div>
              <div className="text-xs text-[#6B6B6B] uppercase tracking-wider" data-id="element-139">
                Intensidades
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative order-1 lg:order-2" data-id="element-140">
          <div className="absolute inset-0 bg-[#FF6B1A] rounded-full blur-[120px] opacity-20 scale-75" data-id="element-141" />
          <div className="relative aspect-square w-full" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/pTGytDbuUzhmhP211ntxKR/PRINCIPAL.png" alt="Luz LED portátil para lectura - vista principal" className="absolute inset-0 w-full h-full object-contain" data-id="element-143" />
          </div>
        </motion.div>
      </div>
    </section>;
}